import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface Props {
  label: string
  value: string
  borderColor: string
  testId?: string
  left: number
  top: number
  height?: number
  borderRadius?: string
}

export function DonutHoverPill({
  label,
  value,
  borderColor,
  testId,
  left,
  top,
  height = 31,
  borderRadius = '7.74px',
}: Props) {
  return (
    <Box
      data-testid={testId}
      sx={{
        position: 'absolute',
        left: left + 12,
        top: top + 12,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        px: '8px',
        height,
        bgcolor: '#fff',
        border: `1.5px solid ${borderColor}`,
        borderRadius,
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        zIndex: 2,
        boxShadow: '0 2px 8px rgba(15, 23, 42, 0.08)',
      }}
    >
      <Typography
        sx={{
          fontSize: '12.387px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          color: '#000',
          lineHeight: '18.58px',
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: '12.387px',
          fontFamily: '"Plus Jakarta Sans", Inter, sans-serif',
          fontWeight: 700,
          color: '#000',
          lineHeight: '18.58px',
        }}
      >
        {value}
      </Typography>
    </Box>
  )
}
